import {
  ApiRoute,
  Application,
  ApplicationSchema,
  ApplicationWithDetail,
  ApplicationWithDetailSchema,
  CreateApplication,
  CreateApplicationResponse,
  CreateApplicationResponseSchema,
  ListApplicationsQuery,
  PageData,
  PageDataSchema,
  RequestSupplement,
  UpdateApplicationStatus,
  getApiRoute
} from "@humanex/interfaces";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class ApplicationApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.APPLICATION),
      requireAuth: true
    });
  }

  async create(dto: CreateApplication): Promise<CreateApplicationResponse> {
    return this.post("", CreateApplicationResponseSchema, dto);
  }

  async getList(params?: Partial<ListApplicationsQuery>): Promise<PageData<ApplicationWithDetail>> {
    const query = new URLSearchParams();
    if (params?.status) query.set("status", params.status);
    if (params?.page != null) query.set("page", String(params.page));
    if (params?.limit != null) query.set("limit", String(params.limit));
    const qs = query.toString();
    return this.get(qs ? `?${qs}` : "", PageDataSchema(ApplicationWithDetailSchema));
  }

  async getOne(id: string): Promise<ApplicationWithDetail> {
    return this.get(id, ApplicationWithDetailSchema);
  }

  async cancel(id: string): Promise<Application> {
    return this.delete(id, ApplicationSchema);
  }

  async getListByProgram(
    programId: string,
    params?: Partial<ListApplicationsQuery>
  ): Promise<PageData<ApplicationWithDetail>> {
    const query = new URLSearchParams({ programId });
    if (params?.status) query.set("status", params.status);
    if (params?.page != null) query.set("page", String(params.page));
    if (params?.limit != null) query.set("limit", String(params.limit));
    return this.get(`/program/${programId}?${query.toString()}`, PageDataSchema(ApplicationWithDetailSchema));
  }

  async updateStatus(id: string, data: UpdateApplicationStatus): Promise<Application> {
    return this.patch(`${id}/status`, ApplicationSchema, data);
  }

  async requestSupplement(id: string, data: RequestSupplement): Promise<Application> {
    return this.post(`${id}/supplement`, ApplicationSchema, data);
  }
}
